import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

export type ConfirmationDialogType = 'warning' | 'success' | 'error' | 'info';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [
    CommonModule,
    Dialog,
    ButtonModule
  ],
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.scss'
})
export class ConfirmationDialog {
  @Input() visible: boolean = false;
  @Input() type: ConfirmationDialogType = 'warning';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() confirmButtonText: string = 'Confirmar';
  @Input() cancelButtonText: string = 'Cancelar';
  @Input() modal: boolean = true;
  @Input() closable: boolean = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  onCloseDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onConfirmClick() {
    this.onConfirm.emit();
  }

  onCancelClick() {
    this.onCancel.emit();
    this.onCloseDialog();
  }

  get iconClass(): string {
    const icons = {
      warning: 'pi pi-exclamation-triangle',
      success: 'pi pi-check-circle',
      error: 'pi pi-times-circle',
      info: 'pi pi-info-circle'
    };
    return icons[this.type];
  }

  get containerClass(): string {
    return `confirmation-dialog-container ${this.type}`;
  }

  getIconStyle(): { color: string } {
    const colors = {
      success: '#ffffff',
      warning: '#62581a',
      error: '#ffffff',
      info: '#001117'
    };
    return { color: colors[this.type] };
  }
}
